import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import CMSHome from './pages/CMS/CMSHome';
import CMSPages from './pages/CMS/CMSPages';
import CMSContent from './pages/CMS/CMSContent';
import LicenseList from './pages/License/LicenseList';
import LicenseCreate from './pages/License/LicenseCreate';
import LicenseEdit from './pages/License/LicenseEdit';
import LicenseTiers from './pages/License/LicenseTiers';
import PlanSelectionRequests from './pages/License/PlanSelectionRequests';
import SupportTicketsList from './pages/Support/SupportTicketsList';
import SupportTicketDetails from './pages/Support/SupportTicketDetails';
import Reports from './pages/Reports/Reports';
import './App.css';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div>Loading...</div>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/*"
            element={
              <PrivateRoute>
                <Layout>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/cms" element={<CMSHome />} />
                    <Route path="/cms/pages" element={<CMSPages />} />
                    <Route path="/cms/content" element={<CMSContent />} />
                    <Route path="/licenses" element={<LicenseList />} />
                    <Route path="/licenses/create" element={<LicenseCreate />} />
                    <Route path="/licenses/edit/:id" element={<LicenseEdit />} />
                    <Route path="/licenses/tiers" element={<LicenseTiers />} />
                    <Route path="/licenses/plan-requests" element={<PlanSelectionRequests />} />
                    <Route path="/support-tickets" element={<SupportTicketsList />} />
                    <Route path="/support-tickets/:id" element={<SupportTicketDetails />} />
                    <Route path="/reports" element={<Reports />} />
                  </Routes>
                </Layout>
              </PrivateRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;


